module.exports = __webpack_public_path__ + "img/kuchynska-linka.ed678e86.svg";